export const HOTEL_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
  "#3B82F6",
  "#2563EB",
  "#1D4ED8",
];

export const formatHotelMoney = (
  amount,
  currency = "NGN",
  locale = "en-US",
) => {
  let formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);

  if (currency === "NGN") {
    formatted = formatted.replace(/^NGN/, "₦");
  } else if (currency === "USD") {
    formatted = formatted.replace(/^USD/, "$");
  }

  return formatted;
};

export const formatHotelPercentage = (value) => {
  const numericValue = Number(value) || 0;

  return `${numericValue.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};

export const getHotelSummaryCards = (summaryMetrics) =>
  Object.entries(summaryMetrics || {}).map(([key, metric]) => ({
    ...metric,
    value:
      key === "occupancyRate" || key === "repeatBookings"
        ? formatHotelPercentage(metric.value)
        : metric.value,
  }));

export const getHotelTrendData = (trendPayload) => {
  const labels = trendPayload?.labels || [];
  const datasets = trendPayload?.datasets || [];

  const revenueDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("revenue"),
  );
  const roomNightsDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("room nights"),
  );

  return labels.map((label, index) => ({
    month: label,
    revenue: revenueDataset?.data?.[index] || 0,
    roomNights: roomNightsDataset?.data?.[index] || 0,
  }));
};

export const getHotelStarRatingBreakdown = (breakdownsData) =>
  breakdownsData?.data?.starRatingBreakdown?.map((item) => ({
    ...item,
    name: item.category,
    value: item.revenue,
  })) || [];

export const getHotelUserTypeBreakdown = (breakdownsData) =>
  breakdownsData?.data?.revenueByUserType?.map((item) => ({
    ...item,
    name: item.userType,
    value: item.revenue,
  })) || [];
